import { ActionTree } from 'vuex';
import { TblUpdateNewsState } from './types';
import { RootState } from '../../types';
import { defaultBackendTblUpdateNews } from '@/shared/backend/tblUpdateNews';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import tblUpdateNews, {
  BereichListResult,
  CategoryListResult,
  AuthorListResult,
  Value,
  TblUpdateNews,
} from '@/shared/model/tblUpdateNews';
import { AxiosResponse } from 'axios';
import i18n from '@/i18n';
// import { CONST } from '../utils/Constants';

const logger = new Logger('actions.tblUpdateDocument');
export const actions: ActionTree<TblUpdateNewsState, RootState> = {
  getTblUpdateNews({ commit, dispatch, getters, rootGetters }, payload?: { searchParams?: any; newsSearchData?: any }) {
    commit('setUpdateNewsIsLoading', true);
    let searchParams = payload?.searchParams ?? getters.getTblUpdateNewsSearchParams;
    let newsSearchData = payload?.newsSearchData || {};
    return defaultBackendTblUpdateNews
      .getTblUpdateNews(searchParams, newsSearchData)
      .then((response: AxiosResponse<Value>) => {
        commit('setTblUpdateNews', response.data);
        commit('setUpdateNewsIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setUpdateNewsIsLoading', false);
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getBereichList({ commit, dispatch }, payload: any) {
    let searchData = payload?.searchData || {};
    return defaultBackendTblUpdateNews
      .getBereichList(searchData)
      .then((response: AxiosResponse<BereichListResult[]>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getCategoryList({ commit, dispatch }, payload: any) {
    let searchData = payload?.searchData || {};
    return defaultBackendTblUpdateNews
      .getCategoryList(searchData)
      .then((response: AxiosResponse<CategoryListResult[]>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getAuthorList({ commit, dispatch }, payload: any) {
    let searchData = payload?.searchData || {};
    return defaultBackendTblUpdateNews
      .getAuthorList(searchData)
      .then((response: AxiosResponse<AuthorListResult[]>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getAddNewsCompleted({ commit, dispatch }, payload: { id: number; zrMaster: string; contactEmail?: string }) {
    return defaultBackendTblUpdateNews
      .getAddNewsCompleted(payload)
      .then(
        (
          response: AxiosResponse<{
            result: TblUpdateNews;
          }>
        ) => {
          return response.data.result;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getCanselNewsCompleted({ commit, dispatch }, payload: { id: number; zrMaster: string; contactEmail?: string }) {
    return defaultBackendTblUpdateNews
      .getCanselNewsCompleted(payload)
      .then(
        (
          response: AxiosResponse<{
            result: TblUpdateNews;
          }>
        ) => {
          return response.data.result;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getCountTopNews({ commit, dispatch }, date: number) {
    return defaultBackendTblUpdateNews
      .getCountTopNews()
      .then((response) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  updateDashboardDate({ commit, dispatch }, date: string) {
    commit('setDashboardDate', date);
  },
};
